/**
 * Subcadenas que no deben mostrarse en PDFs de cotización (suelen ir entre paréntesis
 * dentro del nombre comercial del servicio).
 */
export const PDF_BANNED_SERVICE_NAME_SUBSTRINGS = [
  "(Bluehost)",
  "(Siteground)",
  "(Hostinger)",
  "(Banahosting)",
];

/**
 * Elimina del texto las subcadenas prohibidas para exportación a PDF.
 * @param {string|null|undefined} text
 * @param {readonly string[]} [bannedSubstrings]
 * @returns {string}
 */
export function sanitizeNombreServicioPdf(
  text,
  bannedSubstrings = PDF_BANNED_SERVICE_NAME_SUBSTRINGS
) {
  if (text == null) return "";
  let out = String(text);
  for (const sub of bannedSubstrings) {
    if (!sub) continue;
    out = out.split(sub).join("");
  }
  return out.replace(/\s{2,}/g, " ").trim();
}
